const _apiKey = 'd7c83eb0d2dd40f791ccb65bab1768af'

window.BAO.geoLocationPromise = window.BAO.utils
  .fetchJSON(
    `https://api.ipgeolocation.io/ipgeo?apiKey=${_apiKey}&fields=currency,country_code2,country_name`,
    {
      method: 'GET',
    },
  )
  .then(res => {
    const customerCountryCode = res.country_code2

    window.theme.customer.countryCode = customerCountryCode
  })
  .catch(err => {
    console.error('Geo-location API failed:', err)
    throw err
  })
